import styled from 'styled-components';
import banner from '../../assets/images/LicenseKey.jpg';

export const ConfirmationBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;


  background-image: url(${banner});
    background-repeat: no-repeat;
    background-position: right;
    background-size: cover;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 3vh 5vw;
    box-shadow: #0000000f 0px 0px 1px, #00000021 0px 4px 4px;

  .box {
    width: 691px;
    max-width:90%;
    height: 279px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    border-radius:7px;
  }

  .inputContainer {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    gap:1rem;
    width:100%;
    /* border:solid red; */
    > button {
    border-radius: 5px;
    border: solid 2px var(--primary-color);;
    text-transform: capitalize;
    font-weight: bold;
    width: 7rem;
    height: 2.35rem;
    cursor: pointer;
    border-radius: 5px;
    border: solid 2px var(--primary-color);;
    text-transform: capitalize;
    font-weight: bold;

    cursor: pointer;

  }
`;
